import React from 'react'
import './index.scss'

//other libraries
import { inject, observer } from 'mobx-react'

//material-ui
import { Grid } from '@material-ui/core'

//custom components
import ProductWarehouseScanner from '../../components/complex/ProductWarehouseScanner'

@inject('internal')
@inject('translate')
@observer
export default class ToStorage extends React.Component {
  componentDidMount() {
    this.props.internal.setRoute(this.props.history, this.props.location.pathname)
  }
  
  render() {
    return (
      <div className={'to-storage-container'}>
        <div id='storage-scroll-wrapper' className={'to-storage-edit'}>
          <Grid container direction={'column'} spacing={24} alignItems={'center'}>
            <Grid item xs={12} md={6}>
              <ProductWarehouseScanner
                mode={'to_storage'}
                resetAfterSave
              />
            </Grid>
          </Grid>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/screens/toStorage/index.js